// Packages
import { v4 as uuidv4 } from "uuid";

// Img
import icn_table_cell_change from "assets/images/icons/icn_table_cell_change.svg";
import icn_table_cell_change_hover from "assets/images/icons/icn_table_cell_change_hover.svg";
import icn_table_cell_Logout from "assets/images/icons/icn_table_cell_Logout.svg";
import icn_table_cell_Logout_hover from "assets/images/icons/icn_table_cell_Logout_hover.svg";
import icn_table_cell_Bin from "assets/images/icons/icn_table_cell_Bin.svg";
import icn_table_cell_Bin_hover from "assets/images/icons/icn_table_cell_Bin_hover.svg";

export const defaultActionsDefinition = {
  updateNow: {
    key: "updateNow",
    icon: icn_table_cell_change,
    iconHover: icn_table_cell_change_hover,
    permissions: ["org", "site"],
    label: {
      actionButton: "Update Now",
      prevButton: "Back",
      nextButton: "Next",
      submitButton: "Update Now",
      modal: "Update Firmware Immediately"
    },
    description: {
      info: "Update times may be staggered depending on the number if devices changing firmware.",
      noData: "Please select a series with updates.",
    },
    isHover: false,
    isOpenModal: false,
    uuid: uuidv4(),
    payload: {
      upgradeMethod: "manual",
      isUpgradeNow: true,
    },
  },
  scheduleUpdate: {
    key: "scheduleUpdate",
    icon: icn_table_cell_Logout,
    iconHover: icn_table_cell_Logout_hover,
    permissions: ["org", "site"],
    label: {
      actionButton: "Schedule Update",
      prevButton: "Back",
      nextButton: "Next",
      submitButton: "Apply Now",
      modal: "Set Schedule Firmware Update",
    },
    description: {
      info: "Update times may be staggered depending on the number if devices changing firmware.",
      noData: "Please select a series with scheduled updates.",
    },
    isHover: false,
    isOpenModal: false,
    uuid: uuidv4(),
    payload: {
      upgradeMethod: "schedule",
      isUpgradeNow: false,
    },
  },
  cancelUpdate: {
    key: "cancelUpdate",
    icon: icn_table_cell_Bin,
    iconHover: icn_table_cell_Bin_hover,
    permissions: ["org", "site"],
    label: {
      actionButton: "Cancel Update",
      prevButton: "Cancel",
      nextButton: "Apply Now",
      submitButton: "Apply Now",
      modal: "Cancel Update"
    },
    description: {
      info: "The scheduled firmware update time listed below will be canceled.",
      noData: "Please select a series with scheduled updates.",
    },
    isHover: false,
    isOpenModal: false,
    uuid: uuidv4(),
    payload: {
      upgradeMethod: "manual",
      isUpgradeNow: false,
    },
  },
};

export const defaultDateFormat = {
  all: "YYYY/MM/DD hh:00 A",
  date: "YYYY/MM/DD",
  time: "hh:00 A",
  upgradeWindow: "YYYY/MM/DD hh:00"
}